import { render, staticRenderFns } from "./InscriptionBanner.vue?vue&type=template&id=1fe34f74&"
import script from "./InscriptionBanner.vue?vue&type=script&lang=js&"
export * from "./InscriptionBanner.vue?vue&type=script&lang=js&"
import style0 from "./InscriptionBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports